export enum ProductFilterTypeEnum {
    CUSTOM = 'CUSTOM',
    NAMED = 'NAMED'
}
